<template>
  <div>
    <v-alert v-show="loading">
      Aguarde un instante. Contactando con Servicio de Pago
      <v-progress-linear
        indeterminate
        color="yellow darken-2"
      ></v-progress-linear>
    </v-alert>
    <div class="container">
      <div id="myPaymentForm"></div>
    </div>
    <div>{{ promiseError }}</div>
    {{
      this.empresaId == 1
        ? this.ParametrosGenerales.coinFormPublicKey
        : this.ParametrosGenerales.coinFormPublicKeyFinadi
    }}
  </div>
</template>

<script>
import { http } from '@/axios';
import KRGlue from '@lyracom/embedded-form-glue';

import { mapGetters } from 'vuex';

export default {
  props: {
    creditoId: String,
    importe: Number,
    empresaId: Number,
    orderId: String,
  },
  data() {
    return {
      formId: null,
      loading: true,
      promiseError: '',
    };
  },
  watch: {
    orderId(value) {
      console.log('watching OrderId');
      if (value) {
        this.createForm();
      }
    },
  },
  mounted() {
    //this.createForm();
  },
  computed: {
    ...mapGetters(['ParametrosGenerales']),
  },
  methods: {
    async createForm() {
      this.loading = true;

      const self = this;

      const endpoint = 'https://api.cobroinmediato.tech';
      const publicKey =
        this.empresaId == 1
          ? this.ParametrosGenerales.coinFormPublicKey
          : this.ParametrosGenerales.coinFormPublicKeyFinadi;

      var params = {};
      params.ticket = '3E65AB7D-347C-4F72-8102-D3B75D9C2696';
      params.creditoId = this.creditoId;
      params.orderId = this.orderId;
      params.importe = this.importe;

      let formToken = '';
      await http
        .post('external/coinGetPaymentFormToken', JSON.stringify(params))
        .then((res) => {
          var result = JSON.parse(res);

          //  console.log(result.answer)

          formToken = result.answer.formToken;
        })
        .catch((error) => console.log(error));

      await KRGlue.loadLibrary(
        endpoint,
        publicKey
      ) /* Load the remote library */
        .then(({ KR }) =>
          KR.setFormConfig({
            /* set the minimal configuration */
            formToken: formToken,
            'kr-language': 'es-ES',
            'kr-hide-debug-toolbar': true,
          })
        )
        .then(({ KR }) =>
          KR.addForm('#myPaymentForm')
        ) /* create a payment form */
        .then(({ KR, result }) => {
          this.formId = result.formId;
          KR.showForm(result.formId);

          //piso el evento onsubmit del form para hacer lo que necesito
          document.getElementById('myPaymentForm').onSubmit =
            //este evento se dispara cuando vuelve la respuesta del formulario validado
            $(document).ready(function () {
              KR.onSubmit(function (event) {
                $('.kr-payment-button > span:first').html(
                  event.clientAnswer.orderStatus
                );
                $('.kr-spinner').hide();
                $('.kr-payment-button > span:first').show();

                // console.log('CARD DETAILS')
                // console.log(event.clientAnswer.transactions[0].transactionDetails.cardDetails);

                let token =
                  event.clientAnswer.transactions[0].paymentMethodToken;
                let mesVto =
                  event.clientAnswer.transactions[0].transactionDetails
                    .cardDetails.expiryMonth;
                let anioVto =
                  event.clientAnswer.transactions[0].transactionDetails
                    .cardDetails.expiryYear;
                let numTarjetaTapado =
                  event.clientAnswer.transactions[0].transactionDetails
                    .cardDetails.pan;
                let bancoEmisor =
                  event.clientAnswer.transactions[0].transactionDetails
                    .cardDetails.issuerName;
                let numeroAutorizacion =
                  event.clientAnswer.transactions[0].transactionDetails
                    .cardDetails.authorizationResponse.authorizationNumber;

                //let nombreTitular = event.clientAnswer.transactions[0].transactionDetails.cardDetails.cardHolderName;

                self.emitResult(
                  token,
                  mesVto,
                  anioVto,
                  numTarjetaTapado,
                  bancoEmisor,
                  numeroAutorizacion
                );
                /* segun lo que devuelvo en la funcion esta puedo hacer que frene la ejecucion para manejar el evento yo o que siga
                 * true: kr-post-success-url is called using POST
                 * false: kr-post-success-url is not called, execution stops.
                 */

                KR.removeForms();
                self.loading = false;

                return true;
              }).catch((error) => console.log(error));
            });
        }) /* show the payment form */
        .catch(
          (error) =>
            (this.promiseError = error + ' (ver consola para más detalles)')
        )
        .then((self.loading = false));
    },
    emitResult(
      token,
      mesVtoTarjeta,
      anioVtoTarjeta,
      numTarjetaTapado,
      bancoEmisor,
      authNumber
    ) {
      let datosTarjeta = {
        tarjetaValidada: true,
        token: token,
        mesVto: mesVtoTarjeta,
        anioVto: anioVtoTarjeta,
        numTarjetaTapado: numTarjetaTapado,
        bancoEmisor: bancoEmisor,
        numeroAutorizacion: authNumber,
      };

      this.$emit('token-generado', datosTarjeta);
    },
  },
  beforeDestroy: function () {
    // console.log('destroying')
    KR.removeForms();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
